import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';

import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition);

Vue.prototype.$ELEMENT = { size: 'medium' };

import {
  Badge,
  Dialog,
  Button,
  Input,
  Select,
  Option,
  Link,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Transfer,
  Popover,
  Pagination,
  Message,
  MessageBox,
  Loading,
  Menu,
  Submenu,
  MenuItem,
  Image,
  Tree,
  Notification,
  Row,
  Col,
  Upload,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tooltip,
  ColorPicker,
  Drawer,
  InputNumber,
  Cascader,
  Progress,
  Slider,
  Tabs,
  TabPane,
  Descriptions,
  DescriptionsItem,
  Autocomplete,
  Steps,
  Step,
  Tag,
  Timeline,
  TimelineItem,
  Carousel,
  CarouselItem
} from 'element-ui';

Vue.use(Badge);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Link);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Transfer);
Vue.use(Popover);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Checkbox);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Image);
Vue.use(Tree);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Tooltip);
Vue.use(ColorPicker);
Vue.use(Drawer);
Vue.use(InputNumber);
Vue.use(Cascader);
Vue.use(Progress);
Vue.use(Slider);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Autocomplete);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Tag);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Carousel);
Vue.use(CarouselItem);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
